export default "__VITE_ASSET__BodKKtbn__"